import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Template } from '../../Components/Template/template'
import {
    AlertType, Cidade, ContatoEmpresa, DadosCNPJ, EmpresaAttributes, Estado, InputsRefs, ObsEmpresa, Parceiro, RetAPI, barraVermelhoAzul,
    bgBlue, bgRed, classBorderLabelDark, classBt, classDivBackground, classDivBody, classDtCriarAtt, classInput, classInputDark,
    classLabel, classLabelDark, classUserCriarAtt, classWeigthBt, classbtAzul, classbtAzulEscuro, classbtCinzaClaro,
    classbtColunasAzul, classbtColunasVermelho, focusLabelRed, focusRed
} from '../../Utils/Types'
import { IoEye, IoFolderOpen, IoSave } from 'react-icons/io5'
import { Icone } from '../../Components/Icones/Index'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faClipboardList, faEnvelope, faFolder, faMessage } from '@fortawesome/free-solid-svg-icons'
import { Link, useParams } from 'react-router-dom'
import { RegimesTributarios } from '../../Utils/Global'
import { EmpresaService } from './EmpresaService'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import InputMask from 'react-input-mask'
import { ModalConsultaCNPJ } from '../../Components/ModalConsultaCNPJ/modal-consulta-cnpj'
import { ModalCadObsEmpresa } from '../../Components/ModalCadObsEmpresa/modal-cad-obs-empresa'
import { FcNook } from 'react-icons/fc'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import axios from 'axios'
import { cnpj } from 'cpf-cnpj-validator'
import moment from 'moment'
import { SearchBox } from '../../Components/SearchBox/SearchBox'
import { GridEmpty } from '../../Components/GridEmpty/grid-empty'
import { ToolTips } from '../../Components/ToolTips/tooltips'
import { Funcoes } from '../../Utils/Funcoes'
import { ModalExcluirDados } from '../../Components/Modal/ModalExcluirDados'
import { ModalAuditoria } from '../../Components/ModalAuditoria/modal_auditoria'
import { UtilServices } from '../../Utils/UtilServices'
import { AiOutlineClear } from 'react-icons/ai'
import { FaRegQuestionCircle, FaTrashAlt } from 'react-icons/fa'
import { RiEdit2Fill } from 'react-icons/ri'
import { Tooltip } from 'react-tooltip'
import { GridContatoEmpresa } from '../../Components/GridProducts/GridContatoEmpresa'

type CampoObrigatorio = {
    campo: string,
    erro: boolean,
}

export const EmpresaNewPage = () => {
    // -----------------------------------------------
    // ----------------- SEM USO ---------------------
    // -----------------------------------------------
    /*
       const docValidation: CampoObrigatorio[] = [
   
           { campo: 'cnpj', erro: false },   // Posição 0 do Array. 
       ]
   
       const cepValidation: CampoObrigatorio[] = [
   
           { campo: 'cep', erro: false },  // Posição 0 do Array.
       ]
   
       const [CamposObrigatoriosDoc, setCamposObrigatoriosDoc] = useState<CampoObrigatorio[]>(docValidation)
       const [CamposObrigatoriosCep, setCamposObrigatoriosCep] = useState<CampoObrigatorio[]>(cepValidation)
       const [isRenderTab, setIsRenderTab] = useState<boolean>(false)

    */


    // ----------------- TABS --------------------------------------------------------
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        { index: 1, titulo: 'Contatos', active: false, icon: faEnvelope },
        { index: 2, titulo: 'Observações', active: false, icon: faMessage },
        { index: 3, titulo: 'Auditoria', active: false, icon: faClipboardList },
    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)


    // ------------- CAMPOS OBRIGATORIOS ----------------------------------------------
    const fieldsMandatory: CampoObrigatorio[] = [
        { campo: 'razao', erro: false },                // Posição 0 do Array.
        { campo: 'nome_fantasia', erro: false },        // Posição 1 do Array.  
        { campo: 'cnpj_cpf', erro: false },             // Posição 2 do Array. 
        { campo: 'regime_tributario', erro: false },    // Posição 3 do Array. 
        //{ campo: 'estado', erro: false },             // Posição 4 do Array. 
        { campo: 'id_cidade', erro: false },            // Posição 5 do Array.
    ]

    const [CamposObrigatorios, setCamposObrigatorios] = useState<CampoObrigatorio[]>(fieldsMandatory)


    // ------------------ ATRIBUTOS ---------------------------------------------------
    const { idCompany } = useParams()
    const [id, setId] = useState(0)
    const [attributes, setAttributes] = useState<EmpresaAttributes>()

    // COLUNA 1
    const [razao, setRazao] = useState("")
    const [nomeRazaoCopia, setNomeRazaoCopia] = useState("")
    const [fantasia, setFantasia] = useState("")
    const [Cnpj, setCnpj] = useState("")
    const [ie, setIe] = useState("")
    const [cnae, setCnae] = useState("")
    const [regTrib, setRegTrib] = useState("")
    const [ativo, setAtivo] = useState("S")
    const [idParceiro, setIdParceiro] = useState<number>(0)
    const [parceiros, setParceiros] = useState<Parceiro[]>([])

    // COLUNA 2 
    const [cep, setCep] = useState<string>("")
    const [rua, setEndereco] = useState("")
    const [bairro, setBairro] = useState("")
    const [numero, setNumero] = useState("")
    const [compl, setComplemento] = useState("")
    const [idUf, setIdUf] = useState(0)
    const [siglaUf, setSiglaUf] = useState("")
    const [uf, setUf] = useState<Estado[]>([])
    const [idCity, setIdCity] = useState(0)
    const [cidade, setCidade] = useState<Cidade[]>([])

    // ---------- ATRIBUTOS CONTATO --------------------------------------------------
    const [contatos, setContatos] = useState<ContatoEmpresa[]>([])
    const [idContato, setIdContato] = useState(0)
    const [nomeContatoEmp, setNomeContatoEmp] = useState("")
    const [nomeContatoExcluir, setNomeContatoExcluir] = useState("")
    const [emailContatoEmp, setEmailContatoEmp] = useState("")
    const [setorContatoEmp, setSetorContatoEmp] = useState("")
    const [foneContatoEmp, setFoneContatoEmp] = useState("")
    const [celContatoEmp, setCelContatoEmp] = useState("")
    const [listContato, setListContato] = useState<ContatoEmpresa[]>([])

    // ---------- ATRIBUTOS FEEDBACK -------------------------------------------------
    const [visible, setVisible] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [message, setMessage] = useState<string>("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- ATRIBUTOS EXCLUSÃO --------------------------------------------------
    const [loadingExcluir, setLoadingExcluir] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [modalShowOBS, setModalShowOBS] = useState(false)
    const [idExcluir, setIdExcluir] = useState(0)

    // ---------- ATRIBUTOS AUDITORIA -------------------------------------------------
    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")

    // ---------- ATRIBUTOS AUDITORIA CONTATO -----------------------------------------
    const [listAuditoriaContato, setListAuditoriaContato] = useState<ContatoEmpresa>()

    // ---------- MODALS --------------------------------------------------------------
    const [modalConsultaVisible, setModalConsultaVisible] = useState(false)
    const [modalAuditoriaVisible, setModalAuditoriaVisible] = useState(false)

    // --------- lOADING --------------------------------------------------------------
    const [loadingCnpj, setLoadingCnpj] = useState(false)
    const [loadingConsultaCEP, setLoadingConsultaCEP] = useState<boolean>(false)

    // --------- SEARCHBOX ------------------------------------------------------------
    const [visibleSearchBoxParceiro, setVisibleSearchBoxParceiro] = useState<boolean>(false)
    const [visibleSearchBoxUF, setVisibleSearchBoxUF] = useState<boolean>(false)
    const [visibleSearchBoxCity, setVisibleSearchBoxCity] = useState<boolean>(false)

    // -------- ATRIBUTOS OBSERVACAO ---------------------------------------------------
    const [idObs, setIdObs] = useState(0)
    const [tituloObs, setTituloObs] = useState("")
    const [nomeObsExcluir, setNomeObsExcluir] = useState("")
    const [conteudoObs, setConteudoObs] = useState("")
    const [observacoes, setObservacoes] = useState<ObsEmpresa[]>([])
    const [modalCadObsEmpresaVisible, setModalCadObsEmpresaVisible] = useState(false)
    const [loadingObs, setLoadingObs] = useState(false)


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ATRIBUTOS E EFFECT --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const dadosEmpresaLogada = () => {
        const dadosEmpresa = Funcoes.GetDadosEmpresa()

        if (dadosEmpresa !== null) {

            const dadosLocalStorage = dadosEmpresa

            const ufEmpresa = dadosLocalStorage.uf

            const estado = [...attributes?.estados || []].filter((uf) => uf.sigla === ufEmpresa)

            if (estado && estado.length > 0) {
                setIdUf(estado[0].id)
                setarCidades(estado[0].sigla)
                setSiglaUf(estado[0].sigla)
            }
        }
    }

    const getAttributes = async () => {
        setLoading(true)

        try {

            const attr = await EmpresaService.GetAttributes(idCompany)

            setAttributes(attr.data)
            setUf(attr.data.estados)
            setParceiros(attr.data.parceiros)
            //setCidade(attr.cidades)

            const dadosEmpresa = Funcoes.GetDadosEmpresa()

            if (dadosEmpresa !== null) {

                const dadosLocalStorage = dadosEmpresa

                const ufEmpresa = dadosLocalStorage.uf

                const estado = attr.data.estados.filter((uf: any) => uf.sigla === ufEmpresa)

                if (estado && estado.length > 0) {
                    setIdUf(estado[0].id)
                    setarCidades(estado[0].sigla)
                    setSiglaUf(estado[0].sigla)
                }
            }

            /*
            const newParceiroList: DataSearch[] = []
    
            attr.parceiros?.map(
                (parceiro) => {
                    newParceiroList.push({ id: parceiro.id || 0, description: parceiro.nome_fantasia || '' })
                })
    
            setParceiros(newParceiroList)
            */

            if (attr.data && idCompany) {

                const parceiro = attr.data.parceiros.filter((parceiro: any) => parceiro.id === attr.data.empresa?.id_parceiro)
                if (parceiro && parceiro.length > 0) {
                    setIdParceiro(parceiro[0].id)
                }

                const citys = attr.data.cidades.filter((item: any) => item.id === attr.data.empresa?.id_cidade)
                if (citys && citys.length > 0) {
                    setIdCity(citys[0].id)
                }

                const estado = attr.data.estados.filter((uf: any) => uf.sigla === attr.data.empresa?.uf)
                if (estado && estado.length > 0) {
                    setIdUf(estado[0].id)
                }

                setId(attr.data.empresa?.id || 0)
                setRazao(attr.data.empresa?.razao || "")
                setNomeRazaoCopia(attr.data.empresa?.razao || "")
                setFantasia(attr.data.empresa?.nome_fantasia || "")
                setCnpj(attr.data.empresa?.cnpj_cpf || "")
                setIe(attr.data.empresa?.ie_rg || "")
                setCnae(attr.data.empresa?.cnae || "")
                setAtivo(attr.data.empresa?.ativo ? "S" : "N")
                setRegTrib(attr.data.empresa?.regime_tributario.sigla || "")

                setCep(attr.data.empresa?.cep?.toString() || "")
                setEndereco(attr.data.empresa?.endereco || "")
                setBairro(attr.data.empresa?.bairro || "")
                setNumero(attr.data.empresa?.numero || "")
                setComplemento(attr.data.empresa?.complemento || "")
                setSiglaUf(attr.data.empresa.uf || '')

                //setIdCidade(0)
                //setIdCidade(attr.empresa?.cidade|| 0) 

                /*
                const dataFormatada = moment(attr.empresa?.dt_cadastro?.toString() || '').format('DD/MM/YYYY')
                setDtCadastro(dataFormatada)
                */

                if (attr.data.empresa?.dt_cadastro) {
                    const dataFormatadaCriacao = moment(attr.data.empresa?.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (attr.data.empresa?.dt_last_update) {
                    const dataFormatadaAtt = moment(attr.data.empresa?.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setUserCriador(attr.data.empresa?.name_user_insert || '')
                setUsertAtt(attr.data.empresa?.name_user_last_update || '')

                //setIsRenderTab(true)
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível carregar os dados`)

        } finally {
            setLoading(false)
        }

    }

    useEffect(() => {
        getAttributes()
        uppContacts()
        uppObs()
        inputFocus()
    }, [])

    useEffect(() => {
        const newCitys = attributes?.cidades.filter((item: Cidade) => {
            return item.uf.trim() === (attributes?.empresa?.uf?.trim() || siglaUf)
        })

        setCidade(newCitys || [])
    }, [attributes])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
        searchBoxFocus()
    }

    useEffect(() => {

        if (tabs[0].active) {
            inputFocus()
        } else {
            InputfocusContato()
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- INPUTS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const razaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setRazao(e.target.value)
    }

    const fantasiaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFantasia(e.target.value)
    }

    const cnpjChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value.replaceAll('.', '').replaceAll('_', '').replaceAll('-', '').replaceAll('/', '')
        setCnpj(inputValue)
    }

    const ieChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIe(e.target.value)
    }

    const cnaeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCnae(e.target.value)
    }

    const ativoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setAtivo(e.target.value)
    }

    const regTribChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setRegTrib(e.target.value)
    }

    const cepChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value.replaceAll('_', '').replaceAll('-', '')
        setCep(inputValue)

        if (e.target.value && Funcoes.onlyNumber(e.target.value).length === 8) {
            handleConsultaCEP(e.target.value)
        } else if (e.target.value && Funcoes.onlyNumber(e.target.value).length === 0) {

            setEndereco('')
            setBairro('')
            setNumero('')
            setComplemento('')
            setIdCity(0)
            dadosEmpresaLogada()

            updateUfList()
        }
    }

    const handleConsultaCEP = async (cep: string) => {

        setVisible(false)
        setLoadingConsultaCEP(true)

        try {

            const dadosCEP = await Funcoes.ConsultaCEP(cep)

            if (dadosCEP.error) {

                dadosEmpresaLogada()
                setIdCity(0)
                setBairro('')
                setComplemento('')
                setEndereco('')

            } else {

                updateUfList()

                const estado = [...attributes?.estados || []].filter((item) => item.sigla === dadosCEP.data.uf)
                if (estado && estado.length > 0) {
                    setIdUf(estado[0].id)
                    setarCidades(estado[0].sigla)
                    setSiglaUf(estado[0].sigla)
                }

                const cidade = [...attributes?.cidades || []].filter((item) => item.id === dadosCEP.data.ibge)
                if (cidade && cidade.length > 0) {
                    setIdCity(cidade[0].id)
                }

                setBairro(dadosCEP.data.bairro)
                setComplemento(dadosCEP.data.complemento)
                setEndereco(dadosCEP.data.logradouro)

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível consultar o CEP. Por favor, tente novamente`)

        } finally {
            setLoadingConsultaCEP(false)
        }
    }

    const logradouroChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEndereco(e.target.value)
    }

    const bairroChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBairro(e.target.value)
    }

    const numeroChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumero(e.target.value.replace(/[^0-9]/g, ''))
    }

    const complementoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setComplemento(e.target.value)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ESTADO --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearUfSelecionada = useCallback(() => {

        setSiglaUf("")
        setIdUf(0)

        updateUfList()

        setIdCity(0)
        setCidade([])

        setVisibleSearchBoxUF(false)
        boxFocusUF()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */
    }, [attributes?.estados])

    const handleFilterUfClick = useCallback(async (description: string) => {

        if (description === "") {

            updateUfList()
        } else {

            const newUfList = [...attributes?.estados || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setUf(newUfList || [])
        }
    }, [attributes?.estados])

    const handleUfSelectClick = useCallback((v: Estado) => {

        if (v.id > 0) {

            setIdUf(v.id)
            setSiglaUf(v.sigla)
            setarCidades(v.sigla)

        } else {
            setIdUf(0)
            setSiglaUf('')
            setarCidades('')
        }

        updateUfList()

        setIdCity(0)

        setVisibleSearchBoxUF(false)
        boxFocusUF()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */

    }, [attributes?.estados])

    const updateUfList = () => {
        const newUfList = [...attributes?.estados || []]
        setUf(newUfList)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CIDADE --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearCidadeSelecionada = useCallback(() => {

        setIdCity(0)
        setarCidades(siglaUf)

        setVisibleSearchBoxCity(false)
        boxFocusCidade()

        /*
        if (idUf === 0) {
            const newCidadeList = [...attributes?.cidades || []]
            setCidade(newCidadeList)
            setIdCity(0)
        }
        */
    }, [uf, siglaUf])

    const handleFilterCidadeClick = useCallback(async (description: string) => {

        if (description.trim() === "") {

            setarCidades(siglaUf)
            //const newCidadeList = [...attributes?.cidades || []]
            //setCidade(newCidadeList)

        } else {

            let newCidadeList = []

            newCidadeList = [...attributes?.cidades || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.trim().toLocaleLowerCase()) &&
                    item.uf === siglaUf
            })

            /*
            if (idUf > 0) {
                newCidadeList = [...attributes?.cidades || []].filter((item) => {
                    return item.description.toLocaleLowerCase().startsWith(description.trim().toLocaleLowerCase()) &&
                        item.uf === siglaUf
                })

            } else {

                newCidadeList = [...attributes?.cidades || []].filter((item) => {
                    return item.description.toLocaleLowerCase().startsWith(description.trim().toLocaleLowerCase())
                })
            }
            */

            setCidade(newCidadeList)
        }

    }, [uf, siglaUf])

    const handleCidadeSelectClick = useCallback((v: Cidade) => {

        if (v) {
            setIdCity(v.id)
            setarCidades(siglaUf)
        }

        setVisibleSearchBoxCity(false)
        boxFocusCidade()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */
        // setIdCidade(v.codIBGE)
    }, [uf, siglaUf])

    const setarCidades = async (uf: string) => {
        const citys = await attributes?.cidades.filter(item => item.uf === uf)
        setCidade(citys || [])
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- PARCEIROS ------------------------------------------------------------------------ ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearParceiroClick = useCallback(() => {
        const newParceiroList = [...attributes?.parceiros || []]
        setParceiros(newParceiroList)
        setIdParceiro(0)

        setVisibleSearchBoxParceiro(false)
        boxFocusParceiro()
    }, [attributes?.parceiros])

    const handleFilterParceiroClick = useCallback((description: string) => {

        if (description === "") {

            const newParceiroList = [...attributes?.parceiros || []]
            setParceiros(newParceiroList || [])

        } else {

            const newParceiroList = [...attributes?.parceiros || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setParceiros(newParceiroList || [])
        }

    }, [attributes?.parceiros])

    const handleDataParceiroClick = useCallback((parceiro: Parceiro) => {

        if (parceiro) {
            const newParceiroList = [...attributes?.parceiros || []]
            setParceiros(newParceiroList)
            setIdParceiro(parceiro.id)
        }

        setVisibleSearchBoxParceiro(false)
        boxFocusParceiro()
    }, [attributes?.parceiros])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CONTATO -------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleChangeNomeContato = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNomeContatoEmp(e.target.value)
    }

    const handleChangeEmailContato = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        setEmailContatoEmp(value)
    }

    const handleChangeFoneContato = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFoneContatoEmp(e.target.value)
    }

    const handleChangeCelContato = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCelContatoEmp(e.target.value)
    }

    const handleChangeSetorContato = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSetorContatoEmp(e.target.value)
    }

    const InputfocusContato = () => {
        const inputElement = document.getElementById("nome_contato_emp")
        inputElement?.focus()
    }

    const novoContatoEmpresa = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setIdContato(0)
        setNomeContatoEmp("")
        setEmailContatoEmp("")
        setFoneContatoEmp("")
        setSetorContatoEmp("")
        setCelContatoEmp("")

        setListContato([])

        const inputContactName = document.getElementById('nome_contato_emp')

        if (inputContactName) {
            inputContactName.focus()
        }

    }

    const handleContatoSave = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }
        setLoading(true)

        try {

            const contato: ContatoEmpresa = {
                id: idContato,
                nome: nomeContatoEmp,
                telefone: foneContatoEmp,
                celular: celContatoEmp,
                email: emailContatoEmp,
                setor: setorContatoEmp,
                empresaId: id
            }

            if (id === 0) {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(`Favor salvar a empresa antes de cadastrar um contato`)
                    clearTimeout(timer)
                }, 250)

            } else {

                const retAPI: RetAPI = await EmpresaService.CreateContact(contato)

                if (retAPI.error) {

                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(retAPI.msg || ``)

                } else {

                    setVisible(true)
                    setIdContato(retAPI.id || 0)
                    setMessageType('SUCCESS')
                    setMessage(idContato > 0 ? `Dados do contato da empresa atualizados com sucesso` : retAPI.msg || ``)

                    uppContacts()

                    setIdContato(0)
                    setNomeContatoEmp("")
                    setEmailContatoEmp("")
                    setSetorContatoEmp("")
                    setFoneContatoEmp("")
                    setCelContatoEmp("")
                }
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(idContato > 0 ? `Não foi possível atualizar os dados do contato. Por favor, tente novamente` : `Não foi possível salvar os dados do contato. Por favor, tente novamente`)

        } finally {

            InputfocusContato()
            setListContato([])
            setLoading(false)
        }
    }

    const handleContactEdit = useCallback((item: ContatoEmpresa) => {

        if (listContato.length > 0) {
            setListContato([])
        }

        setMessageType((prevMessageType) => {
            if (prevMessageType === 'DANGER') {
                setVisible(false)
            }
            return prevMessageType // Mantém o valor inalterado
        })

        setIdContato(item.id || 0)
        setNomeContatoEmp(item.nome || '')
        setEmailContatoEmp(item.email || '')
        setSetorContatoEmp(item.setor || '')
        setFoneContatoEmp(item.telefone || '')
        setCelContatoEmp(item.celular || '')

        setListContato([item])
        InputfocusContato()

    }, [])

    const uppContacts = async () => {

        if (parseInt(idCompany || id.toString()) > 0) {

            try {

                const newContactsList = await EmpresaService.BuscarContatos(parseInt(idCompany || id.toString()) || 0)
                setContatos(newContactsList.data)

            } catch (error) {

                setVisible(true)
                setMessageType('DANGER')
                setMessage(`Houve um erro ao buscar os contatos atualizados`)

            }
        }
    }

    const handleExcluirClick = useCallback(async (item: ContatoEmpresa) => {

        setMessageType((prevMessageType) => {
            if (prevMessageType === 'DANGER') {
                setVisible(false)
            }
            return prevMessageType // Mantém o valor inalterado
        })

        setModalShow(true)
        setIdExcluir(item.id || 0)
        setNomeContatoExcluir(item.nome || '')

        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

        if (divPerfil) {
            divPerfil.classList.add('hidden')
        }

    }, [])

    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setVisible(false)
        setLoadingExcluir(true)

        try {

            const retAPI = await EmpresaService.DeleteContato(idExcluir, motivo, senha)

            if (!retAPI.error) {

                handleReloatContacts()

                if (idContato === idExcluir) {
                    novoContatoEmpresa()
                }

                const timer = setTimeout(() => {
                    setModalShow(false)
                    clearTimeout(timer)
                }, 1000)

            } else {

                handleReloatContactsError(retAPI.msg || 'Erro ao exlcuir')
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível excluir o contato. Por favor, tente novamente`)

        } finally {
            setLoadingExcluir(false)
        }
    }, [idExcluir, idContato])

    const handleReloatContacts = async () => {
        setVisible(false)

        const timer = setTimeout(() => {
            setVisible(true)
            setMessageType("SUCCESS")
            setMessage(`Contato excluído com sucesso`)
            uppContacts()

        }, 150)

        return () => clearTimeout(timer)
    }

    const handleReloatContactsError = async (msg: string) => {
        setVisible(false)

        const timer = setTimeout(() => {
            setVisible(true)
            setMessageType("DANGER")
            setMessage(msg)
            uppContacts()
        }, 150)

        return () => clearTimeout(timer)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- AUDITORIA ------------------------------------------------------------------------ ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const abrirModalContatoAuditoria = useCallback((item: ContatoEmpresa) => {
        setListAuditoriaContato(item)
        setModalAuditoriaVisible(true)

        setMessageType((prevMessageType) => {
            if (prevMessageType === 'DANGER') {
                setVisible(false)
            }
            return prevMessageType // Mantém o valor inalterado
        })

    }, [])

    const fecharModalAuditoria = useCallback(() => {
        setModalAuditoriaVisible(false)
    }, [])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- OBSERVAÇÃO ----------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleVisualizarObs = (titulo: string, conteudo: string, id: number) => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setTituloObs(titulo)
        setConteudoObs(conteudo)
        setIdObs(id)

        setModalCadObsEmpresaVisible(true)
    }

    const handleSaveObsEmpresaClick = useCallback(async (titulo: string, conteudo: string) => {

        setVisible(false)
        setLoadingObs(true)

        try {

            if (titulo.trim() === "") {

                const timer = setTimeout(() => {
                    setMessage(`Favor informar o título da observação`)
                    setMessageType("DANGER")
                    setVisible(true)
                    clearTimeout(timer)
                }, 250)
                return
            }

            if (conteudo.trim() === "") {

                const timer = setTimeout(() => {
                    setMessage(`Favor informar o conteúdo da observação`)
                    setMessageType("DANGER")
                    setVisible(true)
                    clearTimeout(timer)
                }, 250)
                return
            }

            const retAPI = await EmpresaService.SaveObs(titulo, conteudo, parseInt(idCompany || id.toString()) || 0)

            if (retAPI.error) {

                const timer = setTimeout(() => {
                    setMessage(retAPI.msg || ``)
                    setMessageType("DANGER")
                    setVisible(true)
                    clearTimeout(timer)
                }, 250)

            } else {
                setVisible(true)
                setMessageType("SUCCESS")
                setMessage(`Observação salvo com sucesso`)

                setObservacoes(retAPI.data)
                setModalCadObsEmpresaVisible(false)
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível salvar a observação. Por favor, tente novamente`)

        } finally {
            setLoadingObs(false)
        }
    }, [id, idCompany])

    const uppObs = async () => {
        if (parseInt(idCompany || id.toString()) > 0) {

            try {

                const newObsList = await EmpresaService.BuscarObs(parseInt(idCompany || '0') || 0)
                setObservacoes(newObsList.data)

            } catch (error) {

                setVisible(true)
                setMessageType('DANGER')
                setMessage(`Houve um erro ao buscar as observações atualizadas`)
            }

        }
    }

    const handleExcluirClickObs = useCallback(async (item: ObsEmpresa) => {

        setMessageType((prevMessageType) => {
            if (prevMessageType === 'DANGER') {
                setVisible(false)
            }
            return prevMessageType // Mantém o valor inalterado
        })

        setModalShowOBS(true)
        setIdExcluir(item.id || 0)
        setNomeObsExcluir(item.titulo || '')

        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

        if (divPerfil) {
            divPerfil.classList.add('hidden')
        }

    }, [])

    const handleExcluirObs = useCallback(async (motivo: string, senha: string) => {

        setVisible(false)
        setLoadingExcluir(true)

        try {

            const retAPI = await EmpresaService.DeleteObservacao(idExcluir, motivo, senha)

            if (!retAPI.error) {

                setVisible(true)
                setMessageType("SUCCESS")
                setMessage(`Observação excluída com sucesso`)

                uppObs()

                const timer = setTimeout(() => {
                    setModalShowOBS(false)
                    clearTimeout(timer)
                }, 1000)

            } else {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(retAPI.msg || ``)
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível excluir a observação. Por favor, tente novamente`)

        } finally {
            const timer = setTimeout(() => {
                setLoadingExcluir(false)
                clearTimeout(timer)
            }, 1000)
        }
    }, [idExcluir])

    const handleCloseModalCadObs = useCallback(() => {
        setModalCadObsEmpresaVisible(false)
        setVisible(false)
        const timer = setTimeout(() => {
            setTituloObs("")
            setConteudoObs("")
            setIdObs(0)
            clearTimeout(timer)
        }, 250)
    }, [])

    const abrirModalObs = () => {

        setModalCadObsEmpresaVisible(true)

        if (messageType === 'DANGER') {
            setVisible(false)
        }
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- EMPRESA -------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const novaEmpresa = async () => {

        /*
        setIdUf(0)
        */
        //setarCidades("")
        //setDtCadastro('')
        //const newCidadeList = [...attributes?.cidades || []]
        //setCidade(newCidadeList)
        //setSiglaUf("")

        setId(0)
        setRazao("")
        setFantasia("")
        setCnpj("")
        setIe('')
        setCnae('')
        setAtivo('S')
        setRegTrib('')
        setIdParceiro(0)
        setCep("")
        setEndereco("")
        setBairro("")
        setNumero("")
        setComplemento("")
        setIdCity(0)

        updateUfList()
        dadosEmpresaLogada()

        setContatos([])
        setObservacoes([])

        setDtCriador('')
        setUserCriador('')
        setDtAtt('')
        setUsertAtt('')

        searchBoxFocus()

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        redefinirCampos()
        inputFocus()
    }

    const handleSaveEmpresa = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setLoading(true)
        searchBoxFocus()

        try {

            const empresa = {
                id: id,
                razao: razao,
                nome_fantasia: fantasia,
                bairro: bairro,
                endereco: rua,
                numero: numero,
                cep: cep != '' && cep.length === 8 ? Funcoes.FormatCep(cep) : '',
                complemento: compl,
                ie_rg: ie,
                cnae: cnae,
                id_cidade: idCity,
                cnpj_cpf: Funcoes.FormatDoc(Cnpj),
                regime_tributario: regTrib,
                ativo: ativo === 'S' ? 'S' : 'N',
                id_parceiro: idParceiro
            }

            if (cep.length > 0 && cep.length < 8) {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(`CEP digitado inválido`)
                    clearTimeout(timer)
                }, 250)

                return
            }

            const resp = await EmpresaService.Save(empresa)

            if (resp.error === true) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(resp.msg || ``)
                //checkDadosObrigatorios(resp.field || '')

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setId(resp.id || 0)
                setMessage(id > 0 ? `Dados da empresa atualizados com sucesso` : resp.msg || ``)

                if (resp.dt_cadastro) {
                    const dataFormatadaCriacao = moment(resp.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (resp.dt_last_update) {
                    const dataFormatadaAtt = moment(resp.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setNomeRazaoCopia(resp.data.empresa.razao)
                setUserCriador(resp.name_user_insert || '')
                setUsertAtt(resp.name_user_last_update || '')

                redefinirCampos()

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(id > 0 ? `Não foi possível atualizar os dados da empresa. Por favor, tente novamente` : `Não foi possível salvar os dados da empresa. Por favor, tente novamente`)

        } finally {
            const timer = setTimeout(() => {
                setLoading(false)
                inputFocus()
                clearTimeout(timer)
            }, 1200)
        }
    }

    const abrirModalConsultaCNPJ = () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setModalConsultaVisible(true)
        searchBoxFocus()
    }

    const fecharModalConsultaCNPJ = useCallback(() => {
        setVisible(false)
        setModalConsultaVisible(false)
        inputFocus()
    }, [])

    const inputFocusCNPJ = () => {
        const inputElement = document.getElementById("inputCNPJ")
        inputElement?.focus()
    }

    const handleConsultarCNPJ = useCallback(async (CNPJ: string) => {

        setVisible(false)
        setLoadingCnpj(true)

        try {

            if (CNPJ !== '' && cnpj.isValid(CNPJ)) {

                const dadosCNPJ: DadosCNPJ = await UtilServices.ConsultarCNPJ(CNPJ)

                if (dadosCNPJ.razao) {

                    updateUfList()

                    setRazao(dadosCNPJ.razao || '')
                    setFantasia(dadosCNPJ.fantasia || dadosCNPJ.razao)
                    setEndereco(dadosCNPJ.logradouro || '')
                    setBairro(dadosCNPJ.bairro || '')
                    setNumero(dadosCNPJ.numero?.toString() || '')
                    setCep(dadosCNPJ.cep.replaceAll('.', '').replaceAll('-', '') || '')
                    setComplemento(dadosCNPJ.compl || '')
                    setBairro(dadosCNPJ.bairro || '')
                    setCnpj(dadosCNPJ.cnpj.replaceAll('.', '').replaceAll('_', '').replaceAll('-', '').replaceAll('/', '') || '')
                    setSiglaUf(dadosCNPJ.uf || '')
                    setarCidades(dadosCNPJ.uf || '')
                    setIdUf(dadosCNPJ.id_uf || 0)
                    setIdCity(dadosCNPJ.id_cidade || 0)
                    setAtivo('S')
                    setModalConsultaVisible(false)

                } else {

                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(`Erro ao localizar CNPJ`)

                    inputFocusCNPJ()
                }

            } else {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(`CNPJ inválido`)
                    setLoadingCnpj(false)

                    inputFocusCNPJ()

                    clearTimeout(timer)
                }, 250)
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível consultar o CNPJ. Por favor, tente novamente`)

            inputFocusCNPJ()

        } finally {
            setLoadingCnpj(false)
        }
    }, [attributes?.estados])

    const checkDadosObrigatorios = (field: string): boolean => {

        if (razao.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (fantasia.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (Cnpj.trim() === '' || (!(cnpj.isValid(Cnpj)) || !(Cnpj.replaceAll(".", "").replaceAll("/", "").replaceAll("-", "").replaceAll("_", "").length === 14))) {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (regTrib.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (siglaUf.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (idCity <= 0) {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }



        return false
    }

    const redefinirCampos = async () => {

        const fieldsM: CampoObrigatorio[] = [
            { campo: 'razao', erro: false },   // Posição 0 do Array.
            { campo: 'nome_fantasia', erro: false },   // Posição 1 do Array.  
            { campo: 'cnpj_cpf', erro: false },   // Posição 2 do Array. 
            { campo: 'regime_tributario', erro: false },   // Posição 3 do Array. 
            //{ campo: 'estado', erro: false },   // Posição 4 do Array. 
            { campo: 'id_cidade', erro: false },   // Posição 5 do Array.  
        ]

        setCamposObrigatorios(fieldsM)

    }

    const inputFocus = () => {
        const inputElement = document.getElementById("razao_empresa")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- MODALS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const fecharModalExclusao = useCallback(() => {

        if (messageType == 'SUCCESS') {
            setModalShow(false)
            setModalShowOBS(false)
        }

        setVisible(false)
    }, [messageType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setModalShow(false)
        setModalShowOBS(false)
        setVisible(false)
    }, [])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 1 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefs: InputsRefs = {
        nomeRazao: useRef(null),
        nomeFantasia: useRef(null),
        cnpj: useRef(null),
        ieRg: useRef(null),
        cnae: useRef(null),
        ativo: useRef(null),
        tributario: useRef(null),
        parceiro: useRef(null),
        cep: useRef(null),
        endereco: useRef(null),
        bairro: useRef(null),
        numero: useRef(null),
        complemento: useRef(null),
        uf: useRef(null),
        cidade: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[0].active) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            searchBoxFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefs[keys[nextIndex]].current?.disabled || inputsRefs[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            if (nextIndex === 7) {
                setVisibleSearchBoxParceiro(true)
                inputFocusParceiro()
            }

            if (nextIndex === 13) {
                setVisibleSearchBoxUF(true)
                inputFocusUF()
            }

            if (nextIndex === 14) {
                setVisibleSearchBoxCity(true)
                inputFocusCidade()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefs[keys[nextIndex]].current?.focus()
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab' && tabs[0].active) {

                event.preventDefault()

                const inputSearchParceiro = document.getElementById('inputSearchBox-parceiro') as HTMLInputElement
                const inputSearchUf = document.getElementById('inputSearchBox-uf') as HTMLInputElement
                const inputSearchCidade = document.getElementById('inputSearchBox-cidade') as HTMLInputElement

                if (document.activeElement === inputSearchParceiro) {
                    inputsRefs['cep'].current?.focus()
                    setVisibleSearchBoxParceiro(false)

                } else if (document.activeElement === inputSearchUf) {
                    clickSearchBoxCidade()
                    setVisibleSearchBoxUF(false)

                } else if (document.activeElement === inputSearchCidade) {
                    inputsRefs['nomeRazao'].current?.focus()
                    setVisibleSearchBoxCity(false)
                }

            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [tabs])

    const searchBoxFocus = () => {
        setVisibleSearchBoxUF(false)
        setVisibleSearchBoxCity(false)
        setVisibleSearchBoxParceiro(false)
    }

    // PARCEIRO ------------------------------------------------
    const boxFocusParceiro = () => {
        // Move o foco para o input correspondente à chave 'parceiro'.
        inputsRefs['parceiro'].current?.focus()
    }

    const clickSearchBoxParceiro = useCallback(() => {
        setVisibleSearchBoxParceiro((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no Parceiro
                setVisibleSearchBoxUF(false)
                setVisibleSearchBoxCity(false)
                inputFocusParceiro()
            }
            return newState
        })

        boxFocusParceiro() // Sempre executa ao clicar
    }, [])

    const inputFocusParceiro = () => {
        let inputSearch = document.getElementById(`inputSearchBox-parceiro`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // ESTADO --------------------------------------------------
    const boxFocusUF = () => {
        // Move o foco para o input correspondente à chave 'uf'.
        inputsRefs['uf'].current?.focus()
    }

    const clickSearchBoxUF = useCallback(() => {
        setVisibleSearchBoxUF((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no UF
                setVisibleSearchBoxCity(false)
                setVisibleSearchBoxParceiro(false)
                inputFocusUF()
            }
            return newState
        })

        boxFocusUF() // Sempre executa ao clicar
    }, [])

    const inputFocusUF = () => {
        let inputSearch = document.getElementById(`inputSearchBox-uf`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // CIDADE ----------------------------------------------------
    const boxFocusCidade = () => {
        // Move o foco para o input correspondente à chave 'cidade'.
        inputsRefs['cidade'].current?.focus()
    }

    const clickSearchBoxCidade = useCallback(() => {
        setVisibleSearchBoxCity((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca na Cidade
                setVisibleSearchBoxUF(false)
                setVisibleSearchBoxParceiro(false)
                inputFocusCidade()
            }
            return newState
        })

        boxFocusCidade() // Sempre executa ao clicar
    }, [])

    const inputFocusCidade = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cidade`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 2 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefsContato: InputsRefs = {
        nomeContato: useRef(null),
        emailContato: useRef(null),
        telefoneContato: useRef(null),
        celularContato: useRef(null),
        setorContato: useRef(null),
    }

    const handleTabPressContato = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[1].active) {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefsContato)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefsContato[keys[nextIndex]].current?.disabled || inputsRefsContato[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefsContato[keys[nextIndex]].current?.focus()
        }
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 3 e 4 ------------------------------------------------------------------ ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab' && (tabs[2].active || tabs[3].active)) {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [tabs])

    //-------------------------------------------------------------- CODIGO SEM USO -----------------------------------------------------------------------------
    const dtCadastroChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        //setDtCadastro(e.target.value)
    }

    const handleChangeEstado = (e: React.ChangeEvent<HTMLSelectElement>) => {
        //setSiglaUf(e.target.value)
        //setarCidades(e.target.value)
    }

    const handleCidadeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        //setIdCidade(parseInt(e.target.value))
    }

    const buscarCidadePorCep = () => {

        /*
        if (cep.replace(".", "").length === 9) { // Verifique se o CEP tem 9 dígitos
            axios.get(`https://viacep.com.br/ws/${cep.replace(".", "")}/json/`)
                .then((response: any) => {
                    const { ibge, uf, bairro, complemento, logradouro, erro } = response.data

                    if (!erro) {
                        //setarCidades(uf)
                        //setSiglaUf(uf)
                        //setIdCidade(ibge)
                        setBairro(bairro)
                        setComplemento(complemento)
                        setEndereco(logradouro)

                        
                        setVisible(false)
                        
                        let fieldsM: CampoObrigatorio[] = [

                            { campo: 'cep', erro: false },   // Posição 3 do Array. 

                        ]

                        setCamposObrigatoriosCep(fieldsM)
                        

                    } else {

                        //setarCidades('')
                        //setSiglaUf('')
                        //setIdCidade(0)
                        setBairro('')
                        setComplemento('')
                        setEndereco('')

                        
                        setVisible(true)
                        setMessageType('DANGER')
                        setMessage('CEP não encontrado')

                        let fieldsM: CampoObrigatorio[] = [

                            { campo: 'cep', erro: true },   // Posição 3 do Array. 

                        ]

                        setCamposObrigatoriosCep(fieldsM)
                        

                    }
                })
                .catch((error: any) => {

                    //setarCidades('')
                    //setSiglaUf('')
                    //setIdCidade(0)
                    setBairro('')
                    setComplemento('')
                    setEndereco('')

                    
                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage('Ocorreu um erro ao buscar o CEP')

                    let fieldsM: CampoObrigatorio[] = [

                        { campo: 'cep', erro: true },   // Posição 3 do Array. 

                    ]

                    setCamposObrigatoriosCep(fieldsM)
                    

                })

        } else {
            //setarCidades('')
            //setSiglaUf('')
            //setIdCidade(0)
            setBairro('')
            setComplemento('')
            setEndereco('')

            
            setVisible(true)
            setMessageType('DANGER')
            setMessage('CEP inválido')

            let fieldsM: CampoObrigatorio[] = [

                { campo: 'cep', erro: true },   // Posição 3 do Array. 

            ]

            setCamposObrigatoriosCep(fieldsM)
            
        }
        */
    }

    const handleValidation = () => {

        /*
        if (cnpj.isValid(Cnpj)) {
            setVisible(false)

           
            let fieldsM: CampoObrigatorio[] = [

                { campo: 'cnpj', erro: false },   // Posição 3 do Array. 

            ]

            setCamposObrigatoriosDoc(fieldsM)
            

        } else {
            setVisible(true)
            setMessageType('DANGER')
            setMessage('CPF / CNPJ inválidos')

            
            let fieldsM: CampoObrigatorio[] = [

                { campo: 'cnpj', erro: true },   // Posição 3 do Array. 

            ]

            setCamposObrigatoriosDoc(fieldsM)
            


        }
        */
    }

    const btNovoVisible = parseInt(idCompany || '') > 0 ? 'invisible hidden' : 'visible'
    const ativoEdit = parseInt(idCompany || '0') > 0 ? false : true
    const condCnpjCpf = cnpj.isValid(Cnpj) ? bgBlue : bgRed
    const condCell = celContatoEmp.replace(/[()_\s-]/g, '').length === 11 && celContatoEmp.replace(/[()_\s-]/g, '') != '' || foneContatoEmp.replace(/[()_\s-]/g, '') != '' ? bgBlue : bgRed
    const condFone = foneContatoEmp.replace(/[()_\s-]/g, '').length === 10 && foneContatoEmp.replace(/[()_\s-]/g, '') != '' || celContatoEmp.replace(/[()_\s-]/g, '') != '' ? bgBlue : bgRed

    return (

        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`h-[50px] w-full flex items-center my-3 px-2`}>
                            <FcNook className={`text-slate-700 dark:text-slate-200 ml-2 mr-2`} size="25px" color='#333' />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all`}>{parseInt(idCompany || '') || id > 0 ? `Editar - Empresa - ${nomeRazaoCopia}` : `Cadastro - Empresa`}</span>
                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`h-[60px] flex overflow-x-auto scrollable_horizontal border border-slate-200 dark:border-slate-700`}>
                                {tabs.map((item) => {
                                    return (
                                        <button tabIndex={-1} onClick={() => handleChangeTab(item.index)} key={item.index.toString()}
                                            className={`px-4 font-mono font-bold w-[180px]
                                                ${item.active ?
                                                    `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                    `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                } `}>
                                            <div tabIndex={-1} className={`flex items-center`}>
                                                <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                <span className={`text-sm roboto whitespace-nowrap`}>{item.titulo}</span>
                                            </div>
                                        </button>
                                    )
                                })}

                            </div>

                            <div className={`${tabs[0].active ? 'block' : 'hidden'} relative`}>

                                <div className={`flex flex-col sm:flex-row`} >

                                    <div className={`w-full h-full grid gap-5 grid-cols-12 p-4`}>

                                        <div className={`relative col-span-12 space-y-1`}>
                                            <div className={`flex flex-row `}>
                                                <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300  mr-2`}>Dados Pessoais</span>
                                                <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 cursor-pointer`} size={18} />
                                                <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                    <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                                </Tooltip>
                                            </div>

                                            <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                        </div>

                                        <div className={`relative col-span-12`}>

                                            <div className={`${barraVermelhoAzul} ${razao != '' ? bgBlue : bgRed}`} />
                                            <input ref={inputsRefs.nomeRazao} onKeyDown={(e) => handleTabPress(e, 'nomeRazao')} id="razao_empresa" className={`${classInput} ${classInputDark} ${razao == '' ? focusRed : ''}`} type='text' inputMode='text' maxLength={155} placeholder=" " autoComplete='off' value={razao} onFocus={searchBoxFocus} onChange={razaoChange} />
                                            <label htmlFor="razao_empresa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${razao == '' ? focusLabelRed : ''}`}>Razão Social</label>
                                        </div>

                                        <div className={`relative col-span-12`}>

                                            <div className={`${barraVermelhoAzul} ${fantasia != '' ? bgBlue : bgRed}`} />
                                            <input ref={inputsRefs.nomeFantasia} onKeyDown={(e) => handleTabPress(e, 'nomeFantasia')} id="fantasia_empresa" className={`${classInput} ${classInputDark} ${fantasia == '' ? focusRed : ''}`} type='text' inputMode='text' maxLength={155} autoComplete='off' placeholder=" " value={fantasia} onFocus={searchBoxFocus} onChange={fantasiaChange} />
                                            <label htmlFor="fantasia_empresa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${fantasia == '' ? focusLabelRed : ''}`}>Nome Fantasia</label>
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-6 2xl:col-span-3`}>

                                            <div className={`${barraVermelhoAzul} ${condCnpjCpf}`} />
                                            <InputMask ref={inputsRefs.cnpj} onKeyDown={(e) => handleTabPress(e, 'cnpj')} id='cnpj_empresa' className={`${classInput} ${classInputDark} ${condCnpjCpf == 'bg-red-900' ? focusRed : ``}`} type='text' inputMode='numeric' autoComplete='off' placeholder=" " value={Cnpj} onFocus={searchBoxFocus} onChange={cnpjChange} mask="99.999.999\/9999-99" alwaysShowMask={true} />
                                            <label htmlFor="cnpj_empresa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${condCnpjCpf == 'bg-red-900' ? focusLabelRed : ``}`}>CNPJ</label>
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-6 2xl:col-span-3`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.ieRg} onKeyDown={(e) => handleTabPress(e, 'ieRg')} id="insc_estadual_empresa" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={40} autoComplete='off' placeholder=" " value={ie} onFocus={searchBoxFocus} onChange={ieChange} />
                                            <label htmlFor="insc_estadual_empresa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Insc. Estadual</label>
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-6 2xl:col-span-3`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.cnae} onKeyDown={(e) => handleTabPress(e, 'cnae')} id="cnae_empresa" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={40} autoComplete='off' placeholder=" " value={cnae} onFocus={searchBoxFocus} onChange={cnaeChange} />
                                            <label htmlFor="cnae_empresa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Cnae</label>
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-6 2xl:col-span-3`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <select ref={inputsRefs.ativo} onKeyDown={(e) => handleTabPress(e, 'ativo')} id="ativo_empresa" disabled={ativoEdit} className={`${classInput} ${classInputDark} disabled:cursor-not-allowed`} value={ativo} onFocus={searchBoxFocus} onChange={ativoChange}>
                                                <option value="S">Sim</option>
                                                <option value="N">Não</option>
                                            </select>
                                            <label htmlFor="ativo_empresa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Ativo</label>
                                        </div>

                                        <div className={`relative col-span-12 2xl:col-span-6`}>

                                            <div className={`${barraVermelhoAzul} ${regTrib != '' ? bgBlue : bgRed}`} />
                                            <select ref={inputsRefs.tributario} onKeyDown={(e) => handleTabPress(e, 'tributario')} id="regime_empresa" className={`${classInput} ${classInputDark} ${regTrib == '' ? focusRed : ''}`} value={regTrib} onFocus={searchBoxFocus} onChange={regTribChange}>
                                                <option value=""></option>
                                                {RegimesTributarios.map(item => <option key={item.codigo} value={item.codigo}>{item.descricao}</option>)}
                                            </select>
                                            <label htmlFor="regime_empresa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${regTrib == '' ? focusLabelRed : ''}`}>Tributário</label>
                                        </div>

                                        <div className={`relative col-span-12 2xl:col-span-6`}>

                                            <div ref={inputsRefs['parceiro']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'parceiro')} />
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <SearchBox
                                                dataList={parceiros}
                                                idRegistro={idParceiro}
                                                label='Parceiro'
                                                componentId='parceiro'
                                                visibleTAB={visibleSearchBoxParceiro}
                                                setDataClick={handleDataParceiroClick}
                                                clearDataClick={handleClearParceiroClick}
                                                filterDataClick={handleFilterParceiroClick}
                                                clicado={clickSearchBoxParceiro}
                                            />
                                        </div>

                                        {/*
                                        <div className={`${parseInt(idCompany || '') > 0 ? `visible` : `invisible hidden`} relative col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4 xl:col-span-3 rounded-lg border dark:border-slate-600 mb-3`}>
                                            <InputMask id="data" className={`${classInput} ${classInputDark} cursor-not-allowed`} placeholder=" " value={dtCadastro} onChange={dtCadastroChange} disabled={true} mask='99/99/9999' alwaysShowMask={true} />
                                            <label htmlFor="data" className={`${classLabel} ${classLabelDark}`}>Data</label>
                                        </div>
                                        */}

                                    </div>

                                    <div className={`w-full h-full grid gap-5 grid-cols-12 p-4 sm:h-[50px]`}>

                                        <div className={`relative col-span-12 space-y-1`}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300`}>Endereço</span>
                                            <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-6 xl:col-span-4`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <div className='absolute flex items-center h-full px-2'>

                                                {loadingConsultaCEP &&
                                                    <div className={`absolute h-[20px] w-[20px] animate-spin rounded-full ml-1 border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                        <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                    </div>
                                                }

                                            </div>
                                            <InputMask ref={inputsRefs.cep} onKeyDown={(e) => handleTabPress(e, 'cep')} id="cep_empresa" className={`${classInput} ${classInputDark} ${loadingConsultaCEP ? 'pl-10' : ''}`} type='text' inputMode='numeric' autoComplete='off' placeholder=" " value={cep} onFocus={searchBoxFocus} onChange={cepChange} mask="99999-999" alwaysShowMask={true} />
                                            <label htmlFor="cep_empresa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>CEP</label>
                                        </div>

                                        <div className={`relative col-span-12`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.endereco} onKeyDown={(e) => handleTabPress(e, 'endereco')} id="logradouro_empresa" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={155} autoComplete='off' placeholder=" " value={rua} onFocus={searchBoxFocus} onChange={logradouroChange} />
                                            <label htmlFor="logradouro_empresa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>Logradouro</label>
                                        </div>

                                        <div className={`relative col-span-12 2xl:col-span-6`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.bairro} onKeyDown={(e) => handleTabPress(e, 'bairro')} id="bairro_empresa" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={60} autoComplete='off' placeholder=" " value={bairro} onFocus={searchBoxFocus} onChange={bairroChange} />
                                            <label htmlFor="bairro_empresa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Bairro</label>
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-4 xl:col-span-3 2xl:col-span-2`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.numero} onKeyDown={(e) => handleTabPress(e, 'numero')} id="numero_empresa" className={`${classInput} ${classInputDark}`} type='text' inputMode='numeric' maxLength={20} autoComplete='off' placeholder=" " value={numero} onFocus={searchBoxFocus} onChange={numeroChange} />
                                            <label htmlFor="numero_empresa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Número</label>
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-8 xl:col-span-9 2xl:col-span-4`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.complemento} onKeyDown={(e) => handleTabPress(e, 'complemento')} id="compl_empresa" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={100} autoComplete='off' placeholder=" " value={compl} onFocus={searchBoxFocus} onChange={complementoChange} />
                                            <label htmlFor="compl_empresa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Complemento</label>
                                        </div>

                                        <div className={`relative col-span-12 2xl:col-span-6`}>

                                            <div ref={inputsRefs['uf']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'uf')} />
                                            <div className={`${barraVermelhoAzul} ${idUf > 0 ? bgBlue : bgRed}`} />
                                            <SearchBox
                                                dataList={uf}
                                                idRegistro={idUf || undefined}
                                                label='Estado'
                                                componentId='uf'
                                                borda={true}
                                                visibleTAB={visibleSearchBoxUF}
                                                clearDataClick={handleClearUfSelecionada}
                                                setDataClick={handleUfSelectClick}
                                                filterDataClick={handleFilterUfClick}
                                                clicado={clickSearchBoxUF}
                                            />
                                        </div>

                                        <div className={`relative col-span-12 2xl:col-span-6`}>

                                            <div ref={inputsRefs['cidade']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'cidade')} />

                                            <div className={`${barraVermelhoAzul} ${idCity > 0 ? bgBlue : bgRed}`} />
                                            <SearchBox
                                                dataList={cidade}
                                                idRegistro={idCity || undefined}
                                                label='Cidade'
                                                componentId='cidade'
                                                borda={true}
                                                visibleTAB={visibleSearchBoxCity}
                                                clearDataClick={handleClearCidadeSelecionada}
                                                setDataClick={handleCidadeSelectClick}
                                                filterDataClick={handleFilterCidadeClick}
                                                clicado={clickSearchBoxCidade}
                                            />
                                        </div>

                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <div className={`flex flex-col lg:flex-row ${parseInt(idCompany || '0') > 0 ? 'sm:space-y-0 lg:space-x-0 space-y-1' : 'lg:space-y-0 lg:space-x-4 space-y-4'}`}>

                                        <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/companies" className={`${classbtColunasVermelho} ${classWeigthBt}`} >
                                            <BsBoxArrowInLeft size="20px" className={`mr-[5px]`} /> Voltar
                                        </Link>

                                        <button tabIndex={-1} onClick={abrirModalConsultaCNPJ} className={` ${parseInt(idCompany || '') > 0 || id > 0 || tabs[1].active ? 'invisible hidden' : 'visible'} ${classbtColunasAzul} ${classWeigthBt}`}>
                                            <span>Consultar CNPJ</span>
                                        </button>

                                    </div>

                                    <div className={`flex flex-col lg:flex-row ${parseInt(idCompany || '0') > 0 ? 'sm:space-y-0 lg:space-x-0 space-y-1' : 'lg:space-y-0 lg:space-x-4 space-y-4'}`}>

                                        <button tabIndex={-1} onClick={novaEmpresa} className={`${classBt} ${btNovoVisible} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                            <AiOutlineClear size="20px" className={`mr-[5px]`} />Limpar Campos
                                        </button>

                                        <button tabIndex={-1} onClick={handleSaveEmpresa} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt}`} >
                                            {!loading && <IoSave size="16px" className={`mr-[5px]`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`} >Loading...</span>
                                                </div>
                                            }
                                            {parseInt(idCompany || '0') > 0 || id != 0 ? !loading ? `Atualizar` : `Aguarde` : !loading ? `Salvar` : `Aguarde`}
                                        </button>

                                    </div>

                                </div>
                            </div>

                            <div className={`${tabs[1].active ? 'block' : 'hidden'} relative`}>

                                <div className={`w-full h-full grid gap-5 grid-cols-12 p-4 mt-3`}>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-3`}>
                                        <div className={`${barraVermelhoAzul} ${nomeContatoEmp != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefsContato.nomeContato} onKeyDown={(e) => handleTabPressContato(e, 'nomeContato')} id="nome_contato_emp" className={`${classInput} ${classInputDark} ${nomeContatoEmp != '' ? '' : focusRed}`} type='text' inputMode='text' maxLength={155} placeholder=" " autoComplete='off' value={nomeContatoEmp} onChange={handleChangeNomeContato} />
                                        <label htmlFor="nome_contato_emp" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${nomeContatoEmp != '' ? '' : focusLabelRed}`}>Nome do contato</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-3`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefsContato.emailContato} onKeyDown={(e) => handleTabPressContato(e, 'emailContato')} id="email_contato_emp" className={`${classInput} ${classInputDark} ${idContato != 0 && listContato[0]?.email ? 'cursor-not-allowed' : ''}`} type='email' inputMode='email' maxLength={155} placeholder=" " autoComplete='off' value={emailContatoEmp} disabled={idContato != 0 && listContato[0]?.email ? true : false} onChange={handleChangeEmailContato} />
                                        <label htmlFor="email_contato_emp" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Email</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${condFone}`} />
                                        <InputMask ref={inputsRefsContato.telefoneContato} onKeyDown={(e) => handleTabPressContato(e, 'telefoneContato')} id="fone_contato_emp" className={`${classInput} ${classInputDark} ${condFone == 'bg-red-900' ? focusRed : ``}`} type='tel' inputMode='tel' placeholder=" " autoComplete='off' value={foneContatoEmp} onChange={handleChangeFoneContato} mask="(99) 9999-9999" alwaysShowMask={true} />
                                        <label htmlFor="fone_contato_emp" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${condFone == 'bg-red-900' ? focusLabelRed : ``}`}>Telefone</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${condCell}`} />
                                        <InputMask ref={inputsRefsContato.celularContato} onKeyDown={(e) => handleTabPressContato(e, 'celularContato')} id="celular_contato_emp" className={`${classInput} ${classInputDark} ${condCell == 'bg-red-900' ? focusRed : ``}`} type='tel' inputMode='tel' placeholder=" " autoComplete='off' value={celContatoEmp} onChange={handleChangeCelContato} mask="(99) 99999-9999" alwaysShowMask={true} />
                                        <label htmlFor="celular_contato_emp" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${condCell == 'bg-red-900' ? focusLabelRed : ``}`}>Celular</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefsContato.setorContato} onKeyDown={(e) => handleTabPressContato(e, 'setorContato')} id="setor_contato_emp" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={60} placeholder=" " autoComplete='off' value={setorContatoEmp} onChange={handleChangeSetorContato} />
                                        <label htmlFor="setor_contato_emp" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Setor</label>
                                    </div>

                                </div>

                                <div className={`relative overflow-hidden hover:overflow-auto p-4`}>

                                    <GridContatoEmpresa
                                        contatos={contatos}
                                        auditoriaContact={abrirModalContatoAuditoria}
                                        editContact={handleContactEdit}
                                        excluirContact={handleExcluirClick} />

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end `}>

                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/companies" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                                    </Link>

                                    <button tabIndex={-1} onClick={novoContatoEmpresa} className={`${classBt} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className={`text-white mr-[5px]`} />Limpar Campos
                                    </button>

                                    <button tabIndex={-1} onClick={handleContatoSave} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt}`}>
                                        {!loading && <IoSave size="16px" className='mr-[5px]' />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {idContato != 0 ? !loading ? 'Atualizar' : 'Aguarde' : !loading ? 'Salvar' : 'Aguarde'}
                                    </button>


                                </div>

                            </div>

                            <div className={`${tabs[2].active ? 'block' : 'hidden'} relative`}>

                                <div className={`relative overflow-hidden hover:overflow-auto p-4`}>

                                    <div className={`w-full min-w-[1300px]`}>

                                        <ul className={`w-full h-full bg-blue-800 dark:bg-[#3498DB] text-slate-200`}>

                                            <li className={`h-full`}>

                                                <div className={`w-full flex flex-row h-10 font-mono`}>

                                                    <div className={`flex items-center w-[20%] h-full border border-slate-300  dark:border-slate-700`}>
                                                        <span className={`px-2`}>Título</span>
                                                    </div>

                                                    <div className={`flex items-center w-[55%] h-full border border-slate-300  dark:border-slate-700`}>
                                                        <span className={`px-2`}>Conteúdo</span>
                                                    </div>

                                                    <div className={`flex items-center w-[15%] h-full border border-slate-300  dark:border-slate-700`}>
                                                        <span className={`px-2`}>Data</span>
                                                    </div>

                                                    <div className={`flex items-center w-[10%] h-full border border-slate-300  dark:border-slate-700`}>
                                                        <span className={`px-2`}>Ações</span>
                                                    </div>

                                                </div>

                                            </li>

                                        </ul>

                                    </div>

                                    <div className={`h-auto max-h-[400px] min-w-[1300px] overflow-auto scrollbar-custom dark:scrollbar-custom-dark`}>

                                        <div className={`w-full h-auto bg-slate-50 dark:bg-[#475569] text-black dark:text-slate-200`}>

                                            <ul className={`w-full`}>
                                                {observacoes.length > 0 &&
                                                    observacoes.map((item: any) => {
                                                        return (

                                                            <li key={item.id} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>
                                                                <div className={`w-full flex flex-row min-h-[50px] font-mono`}>

                                                                    <div className={`flex items-center w-[20%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                        <span className={`px-2`}>{item.titulo}</span>
                                                                    </div>

                                                                    <div className={`flex items-center w-[55%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                        <span className={`px-2`}>{item.conteudo}</span>
                                                                    </div>

                                                                    <div className={`flex items-center w-[15%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                        <span className={`px-2`}>{moment(item.dtCadastro).format("DD/MM/YYYY HH:mm")}</span>
                                                                    </div>

                                                                    <div className={`flex items-center justify-center w-[10%] break-all border border-slate-300 dark:border-slate-700`}>

                                                                        <button
                                                                            tabIndex={-1}
                                                                            data-tooltip-content="Vizualizar Obs" data-tooltip-id={'btn-editar-' + item.id}
                                                                            onClick={() => handleVisualizarObs(item.titulo, item.conteudo, item.id)}
                                                                            className={`flex items-center justify-center 
                                                                                text-slate-200 transition-all duration-300 
                                                                                hover:bg-slate-700 w-[30px] h-[30px] rounded-md 
                                                                                bg-slate-400`}>
                                                                            <IoEye size={'20px'} />
                                                                        </button>
                                                                        <ToolTips target={'btn-editar-' + item.id} bgColor='rgb(148, 163, 184)' />

                                                                        <button
                                                                            tabIndex={-1}
                                                                            data-tooltip-content="Excluir Obs" data-tooltip-id={'btn-excluir-' + item.id}
                                                                            onClick={() => handleExcluirClickObs(item)}
                                                                            className={`flex items-center justify-center
                                                                                text-slate-200 transition-all duration-300
                                                                                hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                                                                bg-red-500 ml-2`} >
                                                                            <FaTrashAlt size="15px" />
                                                                        </button>
                                                                        <ToolTips target={'btn-excluir-' + item.id} bgColor='rgb(239, 68, 68)' />

                                                                    </div>

                                                                </div>

                                                            </li>
                                                        )
                                                    })
                                                }

                                                {observacoes.length === 0 &&
                                                    <GridEmpty texto='Nenhuma Observação Existente' />
                                                }

                                            </ul>

                                        </div>

                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end `}>

                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/companies" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                                    </Link>

                                    <button tabIndex={-1} onClick={abrirModalObs} disabled={loading} className={`${classBt} ${classbtAzulEscuro} min-w-[200px] max-w-[200px]`} >
                                        <IoFolderOpen size="16px" className='mr-[5px]' /> Nova Observação
                                    </button>

                                </div>

                            </div>

                            <div className={`${tabs[3].active ? 'block' : 'hidden'} relative h-[400px] sm:h-[200px]`}>

                                <div className={`w-full h-full flex flex-row p-4`}>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userCriacaoEmp" className={`${classUserCriarAtt}`}>Criador</label>
                                            <span id="userCriacaoEmp" className={`${classDtCriarAtt}`} >{userCriador}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtCriacaoEmp" className={`${classUserCriarAtt}`}>Data de Criação</label>
                                            <span id="dtCriacaoEmp" className={`${classDtCriarAtt}`} >{dtCriador}</span>
                                        </div>

                                    </div>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userAttEmp" className={`${classUserCriarAtt}`}>Atualizador</label>
                                            <span id="userAttEmp" className={`${classDtCriarAtt}`} >{usertAtt}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtAttEmp" className={`${classUserCriarAtt}`}>Data de Atualização</label>
                                            <span id="dtAttEmp" className={`${classDtCriarAtt}`} >{dtAtt}</span>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <ModalCadObsEmpresa
                        modalConteudo={conteudoObs}
                        modalTitulo={tituloObs}
                        id={idObs || undefined}
                        loading={loadingObs}
                        show={modalCadObsEmpresaVisible}
                        CloseModalEvent={handleCloseModalCadObs}
                        SaveClick={handleSaveObsEmpresaClick}
                    />

                    <ModalConsultaCNPJ
                        visible={modalConsultaVisible}
                        loading={loadingCnpj}
                        CloseModalEvent={fecharModalConsultaCNPJ}
                        ConsultarCNPJEvent={handleConsultarCNPJ}
                        
                    />

                    <ModalExcluirDados
                        show={modalShow}
                        isLoading={loadingExcluir}
                        message={`Deseja excluir o contato - ${nomeContatoExcluir || ''}?`}
                        closeModalEvent={fecharModalExclusao}
                        excluirEvent={handleExcluir}
                        fecharModalEvent={buttonFecharModalExcluirDados}
                    />

                    <ModalExcluirDados
                        show={modalShowOBS}
                        isLoading={loadingExcluir}
                        message={`Deseja excluir a observação - ${nomeObsExcluir || ''}?`}
                        closeModalEvent={fecharModalExclusao}
                        excluirEvent={handleExcluirObs}
                        fecharModalEvent={buttonFecharModalExcluirDados}
                    />

                    <ModalAuditoria
                        visible={modalAuditoriaVisible}
                        listaAtributos={listAuditoriaContato}
                        closeModalEvent={fecharModalAuditoria}
                    />

                </div>

            </div>

        </Template>
    )
}
